import { render, staticRenderFns } from "./journey-list-panel.vue?vue&type=template&id=2eacabf8&scoped=true&"
import script from "./journey-list-panel.ts?vue&type=script&lang=ts&"
export * from "./journey-list-panel.ts?vue&type=script&lang=ts&"
import style0 from "./journey-list-panel.scss?vue&type=style&index=0&id=2eacabf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eacabf8",
  null
  
)

export default component.exports